<script>
import { TenantApi, ApiRequest } from '@chirhos/chirhos-api'
import { ChiRhos } from '@paladin/core'

let ChiRhosApi = new ChiRhos().api()

var tenantApi = new TenantApi(ChiRhosApi)

export default {
  page() {
    return {
      title: 'Tenant | Subscriptions',
    }
  },
  components: {},
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      subscriptions: null,
      usage: null,
    }
  },
  mounted() {
    // console.log(this.user)
    this.init()
  },
  methods: {
    init() {
      if(this.isTenantOwner)
      {
        tenantApi
          .GetSubscriptions({
            request: new ApiRequest(),
          })
          .then(
            (response) => {
              this.subscriptions = response
            },
            (error) => {
              console.error(error)
              this.$toast(error, 'error')
            }
          )

        tenantApi
          .GetUsage({
            request: new ApiRequest(),
          })
          .then(
            (response) => {
              this.usage = response
            },
            (error) => {
              console.error(error)
              this.$toast(error, 'error')
            }
          )
        }
    },
  },
}
</script>

<template>
  <b-card title="Subscriptions" class="card-profile">
    <p>
      Subscriptions:<br />
      {{ subscriptions }}
      <br /><br />
      Usage:<br />
      {{ usage }}
    </p>
  </b-card>
</template>
